import { NotFound } from '@Components';

export default NotFound;
